import { useEffect, useCallback } from 'react';

const useKeyboardShortcuts = (shortcuts) => {
  const handleKeyDown = useCallback((event) => {
    const { key, ctrlKey, metaKey, shiftKey, altKey } = event;
    const modifierKey = ctrlKey || metaKey;

    for (const shortcut of shortcuts) {
      const {
        key: shortcutKey,
        ctrl = false,
        shift = false,
        alt = false,
        callback,
        preventDefault = true
      } = shortcut;

      if (
        key.toLowerCase() === shortcutKey.toLowerCase() &&
        modifierKey === ctrl &&
        shiftKey === shift &&
        altKey === alt
      ) {
        if (preventDefault) {
          event.preventDefault();
        }
        callback(event);
        break;
      }
    }
  }, [shortcuts]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};

// Common keyboard shortcuts for logs page
export const createLogsKeyboardShortcuts = ({
  onRefresh,
  onExport,
  onClearFilters,
  onToggleRealTime,
  onFocusSearch
}) => [
  {
    key: 'r',
    ctrl: true,
    callback: onRefresh,
    description: 'Refresh logs'
  },
  {
    key: 'e',
    ctrl: true,
    callback: onExport,
    description: 'Export logs'
  },
  {
    key: 'f',
    ctrl: true,
    callback: onFocusSearch,
    description: 'Focus search'
  },
  {
    key: 'l',
    ctrl: true,
    callback: onToggleRealTime,
    description: 'Toggle live updates'
  },
  {
    key: 'Escape',
    callback: onClearFilters,
    description: 'Clear filters'
  }
];

export default useKeyboardShortcuts;
